import * as React from 'react';
export const AccordionContext = React.createContext({});
//# sourceMappingURL=AccordionContext.js.map